// extracted by mini-css-extract-plugin
export default {"footerContainer":"UpdatePlanModal_footerContainer__imjmy","separator":"UpdatePlanModal_separator__withx","body":"UpdatePlanModal_body__P40sU"};